mainProducts = [];
let currentPopup;
let submitButton;
let shedItem;
// let shedVariant= null;
class addon {
    constructor(){
        window.globalVariables.addon_products= [];
        
        // Load consolidated addon data
        this.loadAddonData();
        
        if(document.querySelectorAll("[data-select-box]").length > 0){
            document.querySelectorAll("[data-select-box]").forEach(ele=>{
                ele.addEventListener("change", (event)=>{
                    this.variantChangeCartDrawer(event);
                }) 
            })
        }
        if(document.querySelectorAll("[data-addon-popup]").length > 0){
                document.querySelectorAll("[data-addon-popup]").forEach(ele =>{
                    ele.addEventListener("click" , (event)=>{
                        this._openPopup(event);
                    })
                })
        }
        if (document.querySelector("[data-close-addon-popup]") != null) {
            document.querySelector("[data-close-addon-popup]").addEventListener("click" , (event)=>{
                event.preventDefault();
                let currentEle = event.currentTarget;
                document.querySelector("#addon-popup .modal").classList.remove("open");
                const closestElement = currentEle.closest('#addon-popup');
                if (!closestElement){
                    document.querySelector("#site-overlay").classList.remove("overlay--body");
                    document.body.classList.remove("scroll-fixed");
                }
                
            })
            
        }

        if(document.querySelectorAll("[data-reverse-order-btn]").length > 0){
            document.querySelectorAll("[data-reverse-order-btn]").forEach(ele =>{
                ele.addEventListener("click" , (event)=>{
                    this._reverseOrder(event);
                })
            })
        }
    }

    /**
     * Load addon data from consolidated JSON structure or AJAX
     */
    loadAddonData() {
        // First try consolidated JSON
        const addonDataScript = document.getElementById('addon-products-data');
        if (addonDataScript) {
            try {
                const addon_products = JSON.parse(addonDataScript.textContent);
                addon_products.forEach(item => {
                    mainProducts.push(item);
                    window.globalVariables.addon_products.push(item);
                });
                return;
            } catch (error) {
                console.error('Error parsing addon products data:', error);
            }
        }

        
        // Fallback: Check for old format (for backward compatibility)
        if (window.globalVariables.addon_products.length === 0 && document.querySelectorAll("[data-main-product]").length > 0) {
            document.querySelectorAll("[data-main-product]").forEach(ele => {
                try {
                    let addon_products = JSON.parse(ele.innerText);
                    addon_products.forEach(item => {
                        mainProducts.push(item);
                        window.globalVariables.addon_products.push(item);
                    });
                } catch (error) {
                    console.error('Error parsing legacy addon data:', error);
                }
            });
        }
    }

    variantChangeCartDrawer(event){
        let currentTarget = event.currentTarget;
        const selectedOption = event.target.options[event.target.selectedIndex];
    
        const variantId = selectedOption.getAttribute('data-variant-id');
        const variantPrice = selectedOption.getAttribute('data-variant-price');
        const isAvailable = selectedOption.getAttribute("is_available");
        const maxQty = selectedOption.getAttribute('max-qty');
        let parent_wrap = currentTarget.closest("[data-addon-wrap-variant-id]");
        
        // Check if parent_wrap exists before accessing its elements
        if (!parent_wrap) return;
        
        const priceElement = parent_wrap.querySelector("[data-currentprice]");
        const variantInput = parent_wrap.querySelector("[data-form-variant-id]");
        const maxQtyInput = parent_wrap.querySelector("[data-max-quantity]");
        const atcBtn = parent_wrap.querySelector("[data-atc-btn]");
        
        if (priceElement) priceElement.innerText = variantPrice;
        if (variantInput) variantInput.value = variantId;
        if (maxQtyInput && maxQty) maxQtyInput.value = maxQty;

        if (atcBtn) {
            if (isAvailable == "false") {
                atcBtn.setAttribute("disabled" , "true");
                if (atcBtn.querySelector(".add-text")) {
                    atcBtn.querySelector(".add-text").innerText = "Sold Out";
                }
            } else {
                atcBtn.removeAttribute("disabled");
                if (atcBtn.querySelector(".add-text")) {
                    atcBtn.querySelector(".add-text").innerText = "Add To Cart";
                }
            }
        }

    }

    _openPopup(event){
        let currentTarget = event.currentTarget;
        currentPopup = currentTarget;
        let parent_wrap = currentTarget.closest("[data-addon-wrap-variant-id]");
        let description = parent_wrap.querySelector("[data-description]").innerHTML;
        let src = currentTarget.getAttribute("data-image-url-addon");
        let variantId = parent_wrap.querySelector("[data-form-variant-id]").value;
        let maxQTY =  parent_wrap.querySelector("[data-max-quantity]").value;
        let atcText = parent_wrap.querySelector("[data-atc-btn] .add-text").innerText;

        document.querySelector("[data-image-addon-popup]").src = `//heartland-sheds.myshopify.com/cdn/shop/${src}`;
        document.querySelector("[data-addon-popup-variant-id]").value = variantId;
        document.querySelector("[data-popup-max-quantity]").value = maxQTY;
        document.querySelector("[data-popup-description]").innerHTML = description;
        document.querySelector("#site-overlay").classList.add("overlay--body");
        document.body.classList.add("scroll-fixed");
        document.querySelector("#addon-popup .modal").classList.add("open");
        document.querySelector("[data-popup-atc] .add-text").innerText = atcText;
        

    }

// Function to remove product by variant ID
_reverseOrder(event){
    event.preventDefault();
    submitButton = event.currentTarget;
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    const changeEndpoint = '/cart/change.js';
    if(window.globalVariables.cart.items)
    // Fetch the current cart to get the line items
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cart => {
        window.globalVariables.cart.items = cart.items;

        // Find the line item that matches the given variant ID
        // const lineItem = cart.items.find(item => item.variant_id === variantId);
        const lineItem = cart.items.find(obj => obj.properties['_is_shed'] == "true");
       let index =  cart.items.indexOf(lineItem);
       if (index == 0) {
        window.location.href='/checkout'
       }else{
        if (lineItem) {
            // Remove the item by setting its quantity to 0
            fetch(changeEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItem.key,  // Line item ID (not variant ID)
                    quantity: 0       // Setting quantity to 0 removes the item
                })
            })
            .then(response => response.json())
            .then(data => {
               
                this.addToCart(lineItem);  // Add 1 quantity of the product
            })
            .catch(error => {
                console.error('Error removing product:', error);
            });
        } else {
            console.error('Variant ID not found in cart');
        }
        }
    })
    .catch(error => {
        console.error('Error fetching cart:', error);
    });
}

// Function to add a product back to the cart by variant ID
 addToCart(lineItem) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: lineItem.variant_id,      // Variant ID of the product to add
            quantity: lineItem.quantity , // Quantity of the product to add
            properties : lineItem.properties
        })
    })
    .then(response => response.json())
    .then(data => {
       
        window.location.href='/checkout'
        // Optionally, update the cart UI here
    })
    .catch(error => {
        
    });
}



    

}

new addon()